<template>
	<div class="fertilizer">
		<el-row class="fertilizer_title">
			<el-col :span="12">
				<div class="fertilizer_left">
					设备名
				</div>
			</el-col>
			<el-col :span="12">
				<div class="fertilizer_right">
					操作名称
				</div>
			</el-col>
		</el-row>
		<el-row class="fertilizer_content">
			<el-col :span="8">
				<div class="fertilizer_left">
					水肥一体机
				</div>
			</el-col>
			<el-col :span="16">
				<div class="fertilizer_right">
					<el-button size="small" type="success" link @click="SelectDetalidialog=true">查看详情</el-button>
					<el-button size="small" type="success" link @click="InsertDetalidialog=true">添加记录</el-button>
					<el-button size="small" type="success" link @click="switchDetalidialog=true">开关控制</el-button>
					<el-button size="small" type="danger" link @click="DeleteDetalidialog=true">删除记录</el-button>
				</div>
			</el-col>
		</el-row>
	</div>
	<el-dialog v-model="SelectDetalidialog" title="查看详情" width="500" align-center>
		<el-input placeholder="请输入水肥表id" v-model="wftid" @input="SelectDetalidialogchange" autocomplete="off" />
		<br />
		<table class="SelectDetalidialoginput_table">
			<tr>
				<th class="SelectDetalidialoginput_table_left">ID：</th>
				<td class="SelectDetalidialoginput_table_right">{{wftdetail?.id}}</td>
			</tr>
			<tr>
				<th class="SelectDetalidialoginput_table_left">工作员：</th>
				<td class="SelectDetalidialoginput_table_right">{{wftdetail?.operator}}</td>
			</tr>

			<tr>
				<th class="SelectDetalidialoginput_table_left">施肥时间：</th>
				<td class="SelectDetalidialoginput_table_right">{{wftdetail?.createDate}}</td>
			</tr>
			<tr>
				<th class="SelectDetalidialoginput_table_left">水肥比：</th>
				<td class="SelectDetalidialoginput_table_right">{{wftdetail?.waterFertilizerRatio}}</td>
			</tr>
			<tr>
				<th class="SelectDetalidialoginput_table_left">施肥内容：</th>
				<td class="SelectDetalidialoginput_table_right">{{wftdetail?.fertilizerDetail}}</td>
			</tr>
			<tr>
				<th class="SelectDetalidialoginput_table_left">施肥方式：</th>
				<td class="SelectDetalidialoginput_table_right">{{wftdetail?.useFertilizer}}</td>
			</tr>
			<tr>
				<th class="SelectDetalidialoginput_table_left">施肥名称：</th>
				<td class="SelectDetalidialoginput_table_right">{{wftdetail?.fertilizerName}}</td>
			</tr>
		</table>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="SelectDetalidialog = false">取消</el-button>
			</div>
		</template>
	</el-dialog>
	<el-dialog v-model="InsertDetalidialog" title="添加记录" width="500" align-center>
		<el-form :model="insert">
			<el-form-item label="工作员" label-width="80">
				<el-input v-model="insert.operator" autocomplete="off" />
			</el-form-item>
			<el-form-item label="水肥比" label-width="80">
				<el-input v-model="insert.waterFertilizerRatio" autocomplete="off" />
			</el-form-item>
			<el-form-item label="施肥内容" label-width="80">
				<el-input v-model="insert.fertilizerDetail" autocomplete="off" />
			</el-form-item>
			<el-form-item label="施肥方式" label-width="80">
				<el-input v-model="insert.useFertilizer" autocomplete="off" />
			</el-form-item>
			<el-form-item label="施肥名称" label-width="80">
				<el-input v-model="insert.fertilizerName" autocomplete="off" />
			</el-form-item>
		</el-form>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="InsertDetalidialog = false">取消</el-button>
				<el-button type="primary" @click="ConfirmInsert()">
					确认添加
				</el-button>
			</div>
		</template>
	</el-dialog>
    <el-dialog v-model="switchDetalidialog" title="设备开关" width="500" align-center>
    	<el-switch
    	    v-model="value2"
    	    class="ml-2"
    	    style="--el-switch-on-color: #13ce66; --el-switch-off-color: #525553"
    	  />
    	<template #footer>
    		<div class="dialog-footer">
    			<el-button @click="switchDetalidialog = false">取消</el-button>
    		</div>
    	</template>
    </el-dialog>
    <el-dialog v-model="DeleteDetalidialog" title="查看详情" width="500" align-center>
    	<el-input placeholder="请输入水肥表id" v-model="wftid" @input="SelectDetalidialogchange" autocomplete="off" />
    	<br />
    	<table class="SelectDetalidialoginput_table">
    		<tr>
    			<th class="SelectDetalidialoginput_table_left">ID：</th>
    			<td class="SelectDetalidialoginput_table_right">{{wftdetail?.id}}</td>
    		</tr>
    		<tr>
    			<th class="SelectDetalidialoginput_table_left">工作员：</th>
    			<td class="SelectDetalidialoginput_table_right">{{wftdetail?.operator}}</td>
    		</tr>
    
    		<tr>
    			<th class="SelectDetalidialoginput_table_left">施肥时间：</th>
    			<td class="SelectDetalidialoginput_table_right">{{wftdetail?.createDate}}</td>
    		</tr>
    		<tr>
    			<th class="SelectDetalidialoginput_table_left">水肥比：</th>
    			<td class="SelectDetalidialoginput_table_right">{{wftdetail?.waterFertilizerRatio}}</td>
    		</tr>
    		<tr>
    			<th class="SelectDetalidialoginput_table_left">施肥内容：</th>
    			<td class="SelectDetalidialoginput_table_right">{{wftdetail?.fertilizerDetail}}</td>
    		</tr>
    		<tr>
    			<th class="SelectDetalidialoginput_table_left">施肥方式：</th>
    			<td class="SelectDetalidialoginput_table_right">{{wftdetail?.useFertilizer}}</td>
    		</tr>
    		<tr>
    			<th class="SelectDetalidialoginput_table_left">施肥名称：</th>
    			<td class="SelectDetalidialoginput_table_right">{{wftdetail?.fertilizerName}}</td>
    		</tr>
    	</table>
    	<template #footer>
    		<div class="dialog-footer">
				<el-button @click="DeleteWateringFertilizationTablesDetails()">确认删除</el-button>
    			<el-button @click="DeleteDetalidialog = false">取消</el-button>
    		</div>
    	</template>
    </el-dialog>
    
</template>

<script setup>
	import {
		ref,
		reactive
	} from 'vue';
	import {
		GetWateringFertilizationTablesDetail,
		DeleteWateringFertilizationTablesDetail,
		InsertWateringFertilizationTablesDetail
	} from '@/api/api.js';
	import mitt from '@/utils/bus.js';
	import {
		ElMessage
	} from 'element-plus'
	const value2 = ref()
	//水肥表ID
	let wftid = ref()
	//打开水肥表
	let SelectDetalidialog = ref(false)
	//水肥表
	let wftdetail = ref(null)
	//添加水肥表记录dialog
	let InsertDetalidialog = ref(false)
	//添加水肥表记录dialog
	let DeleteDetalidialog = ref(false)
	
	//开关打开机器
	let switchDetalidialog = ref(false)
	let insertform = ref()
	let insert = ref({
		operator: '',
		waterFertilizerRatio: '',
		fertilizerDetail: '',
		useFertilizer: '',
		fertilizerName: ''
	})

	function SelectDetalidialogchange() {
		GetWateringFertilizationTablesDetail(wftid.value).then(res => {
			wftdetail.value = res.data
		}).catch(err => {
			console.log(err)
		})
	}
	function DeleteWateringFertilizationTablesDetails(){
		DeleteWateringFertilizationTablesDetail(wftid.value).then(res => {
			 ElMessage.success(res.msg);
			 DeleteDetalidialog.value= false;
		}).catch(err => {
			console.log(err)
		})
	}
	const ConfirmInsert = () => {
		if (insert.value.operator == '') {
			ElMessage({
				message: '工作员不能为空',
				type: 'error',
			});
		} else if (insert.value.waterFertilizerRatio == '') {
			ElMessage({
				message: '水肥比不能为空',
				type: 'error',
			});
		} else if (insert.value.fertilizerDetail == '') {
			ElMessage({
				message: '施肥内容不能为空',
				type: 'error',
			});
		} else if (insert.value.useFertilizer == '') {
			ElMessage({
				message: '施肥方式不能为空',
				type: 'error',
			});
		} else if (insert.value.fertilizerName == '') {
			ElMessage({
				message: '施肥名称不能为空',
				type: 'error',
			});
		} else {
			InsertWateringFertilizationTablesDetail(insert.value).then(res => {
				console.log(res.data)
				if (res.data==1) {
					ElMessage({
						message: '添加成功',
						type: 'success',
					});
					InsertDetalidialog.value=false
					mitt.emil('InsertWateringFertilizationTablesDetail','true');
					
				}else{
					ElMessage({
						message: '添加失败',
						type: 'success',
					});
				}
			}).catch(err => {
				console.log(err)
			})
		}


	}
</script>

<style lang="scss">
	.fertilizer {
		padding-left: 5%;
		width: 90%;
		line-height: 30px;
	}

	.fertilizer_title {
		border-bottom: 1px solid #34e2b7;
	}

	.fertilizer_left {
		padding-left: 20px;
	}

	.fertilizer_right {
		width: 100%;
		text-align: center;
	}

	.SelectDetalidialoginput_table_left {
		width: 100px;
		padding-right: 10px;
		text-align: right;
	}

	.SelectDetalidialoginput_table_right {
		width: 400px;
		padding-left: 10px;
	}
</style>